import * as React from 'react';

const PendingActionItemOther24: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect width='26' height='26' rx='13' fill='white' />
		<rect
			x='0.5'
			y='0.5'
			width='25'
			height='25'
			rx='12.5'
			stroke='black'
			stroke-opacity='0.1'
		/>
		<path
			d='M13.0001 2.99976C18.5231 2.9998 23 7.47681 23.0001 12.9998C23.0001 18.5228 18.5232 22.9997 13.0001 22.9998C7.47704 22.9998 3.00012 18.5228 3.00012 12.9998C3.00024 7.47678 7.47712 2.99976 13.0001 2.99976ZM9.92297 12.2312C9.71903 12.2312 9.52325 12.3116 9.37903 12.4558C9.23482 12.6 9.1535 12.7958 9.15344 12.9998C9.15344 13.2037 9.23489 13.3995 9.37903 13.5437C9.52325 13.6879 9.71902 13.7692 9.92297 13.7693H16.0773C16.2812 13.7692 16.477 13.6879 16.6212 13.5437C16.7653 13.3995 16.8458 13.2036 16.8458 12.9998C16.8458 12.7958 16.7654 12.6 16.6212 12.4558C16.477 12.3116 16.2812 12.2313 16.0773 12.2312H9.92297Z'
			fill='#999999'
		/>
	</svg>
);

export default PendingActionItemOther24;
